import axios from "axios";
import { NotProductiveUnitService } from "./service";
import { keycloak } from "../../../../../lib/keycloak";
import { filtersDTO, NotUPResponseDTO, NotUpUpdateDTO } from "./dto";

export class NotProductiveUnitImpl implements NotProductiveUnitService {

    public GetAllProductiveUnit(filters: filtersDTO): Promise<NotUPResponseDTO> {
        return axios.get("/api/productive-unit", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                notificationId: filters.notificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public UpdateUp(data: NotUpUpdateDTO, id: string): Promise<void> {
        return axios.put("/api/productive-unit/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

}